<template>
    <div class="loading entraSuave">
      <div class="half-circle-spinner animaLoad1">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
      </div>
      
      <div class="half-circle-spinner2 animaLoad2">
        <div class="circle2 circle-12"></div>
        <div class="circle2 circle-22"></div>
      </div>

      <Lightning class="loadRaioHion" :configLightning="configLightning" />

      <span class="div-load-text">A &nbsp;CARREGAR...</span>

  </div>
</template>

<script>
//import Lightning from '../efeitos/lightning'

export default {
    name: 'Loading',
    components: { 
      Lightning: () => import(/* webpackChunkName: "LightningLoad" */ "../efeitos/lightning.vue"),
      },
    data() {
      return {
        configLightning: {
            backgroundLightning: '#2e2d2c',
            CorLightning: '#ffd618'
        }
      };
    }
}
</script>

<style>
.loading {
    position: relative;
    width: 100%;
    height: 700px;
    background-color: #2e2d2c;
    overflow: hidden;
}
.entraSuave {
  animation: suavis 1s linear;
  animation-iteration-count: 1;
}

@keyframes suavis {
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
.animaLoad1 {
    position: absolute;
    left:calc(50% - 50px);
    top:calc(30% - 60px);
}
.animaLoad2 {
    position: absolute;
    left:calc(50% - 65px);
    top:calc(30% - 175px);
    transform: rotate(90deg);
}
.loadRaioHion {
    position: absolute !important;
    width: 60px !important;
    height: 66px !important;
    left:calc(50% - 30px) !important;
    top:calc(30% - 43px) !important;
}
.div-load-text {
    text-decoration: none;
    font-family: Helvetica,Arial;
    color: #eee;
    font-size: 0.8em;
    position: absolute;
    left:calc(50% - 60px);
    top:calc(30% + 70px);
    letter-spacing: 3px;
    animation: blinker 3s linear infinite;
}
@keyframes blinker {
  50%{
    opacity: 0;
  }
}

/*************************CIRCULE MENOR ************************************** */
.half-circle-spinner, .half-circle-spinner * {
  box-sizing: border-box;
}
.half-circle-spinner {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
}
.half-circle-spinner .circle {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(100px / 20) solid transparent;
}
.half-circle-spinner .circle.circle-1 {
  border-top-color: #008fac;
  animation: half-circle-spinner-animation 1s infinite;
}
.half-circle-spinner .circle.circle-2 {
  border-bottom-color: #008fac;
  animation: half-circle-spinner-animation 1s infinite alternate;
}
@keyframes half-circle-spinner-animation {
  0% {
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
}

/***************************************************************************** */

/*************************CIRCULE MAIOR ************************************** */
.half-circle-spinner2, .half-circle-spinner2 * {
  box-sizing: border-box;
}
.half-circle-spinner2 {
  width: 130px;
  height: 130px;
  border-radius: 100%;
  position: relative;
}
.half-circle-spinner2 .circle2 {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(100px / 20) solid transparent;
}
.half-circle-spinner2 .circle2.circle-12 {
  border-top-color: #008fac;
  animation: half-circle-spinner2-animation 1.5s infinite;
}
.half-circle-spinner2 .circle2.circle-22 {
  border-bottom-color: #008fac;
  animation: half-circle-spinner2-animation 1.5s infinite alternate;
}
@keyframes half-circle-spinner2-animation {
  0% {
    transform: rotate(360deg);
  }
  100%{
    transform: rotate(0deg);
  }
}
/***************************************************************************** */

</style>
